export default __webpack_public_path__ + "static/media/settings_room_device_mic.c4d27f62.svg";